/**
 * Removes the "__typename" property from the given data object or array recursively.
 *
 * @param {Object|Array} data - The data object or array to remove "__typename" property from.
 * @returns {Object|Array} - The data object or array with "__typename" property removed.
 */
export const removeTypeName = (data: any): any => {
  if (Array.isArray(data)) {
    return data.map((item) => {
      return removeTypeName(item);
    });
  } else if (typeof data === 'object') {
    const newObj: Record<string, any> = {};
    Object.keys(data).forEach((key) => {
      if (key !== '__typename') {
        newObj[key] = removeTypeName(data[key]);
      }
    });
    return newObj;
  }
  return data;
};

export const isRunningAsPWA = (): boolean => {
  return (
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(display-mode: standalone)').matches
  );
};
